var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCai(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3856 8.76609C23.5373 11.9178 23.5373 17.0327 20.3856 20.1844C17.234 23.3361 12.1189 23.3361 8.96727 20.1844C5.8156 17.0327 5.8156 11.9178 8.96727 8.76609C12.1189 5.61443 17.234 5.61443 20.3856 8.76609Z",
    stroke: "#24B632",
    strokeWidth: 1.71576,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83263 26.4543C7.2493 25.421 4.98888 23.5481 3.49055 20.9518C2.01805 18.4072 1.52721 15.5785 1.87596 12.8789",
    stroke: "#24B632",
    strokeWidth: 1.71576,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73291 4.28911C8.92874 2.57119 11.68 1.55078 14.6767 1.55078C17.6087 1.55078 20.3083 2.54535 22.4783 4.19868",
    stroke: "#24B632",
    strokeWidth: 1.71576,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.52 26.4543C22.1034 25.421 24.3638 23.5481 25.8621 20.9518C27.3346 18.4072 27.8254 15.5785 27.4767 12.8789",
    stroke: "#24B632",
    strokeWidth: 1.71576,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCai);
export default __webpack_public_path__ + "static/media/CAI.068eeabb73dbcb9bcc9aab0efbb59e38.svg";
export { ForwardRef as ReactComponent };